const formatDate = (date) => {
  const getDate = date ? new Date(date.replace(/-/g, "/")) : /* @__PURE__ */ new Date();
  let month = "" + (getDate.getMonth() + 1);
  let day = "" + getDate.getDate();
  const year = getDate.getFullYear();
  if (month.length < 2)
    month = "0" + month;
  if (day.length < 2)
    day = "0" + day;
  return [year, month, day].join("-");
};
const offsetDate = (date, operator, numberOfDaysToOffset) => {
  return operator === "+" ? date.getTime() + 24 * 60 * 60 * 1e3 * numberOfDaysToOffset : date.getTime() - 24 * 60 * 60 * 1e3 * numberOfDaysToOffset;
};
const convertDateToUSFormat = (value) => {
  const [year, month, day] = value.split("-");
  return [month, day, year].join("/");
};
const convertDateToUniversalFormat = (value) => {
  const [month, day, year] = value.split("/");
  return [year, month, day].join("-");
};
export {
  convertDateToUSFormat,
  convertDateToUniversalFormat,
  formatDate,
  offsetDate
};
//# sourceMappingURL=date.js.map
